<script>
import { useAlert } from 'dashboard/composables';
import InputRadioGroup from 'dashboard/components/widgets/conversation/InputRadioGroupStylizedAsButton.vue';

export default {
  components: { InputRadioGroup },
  props: {
    reason: {
      type: Object,
      default: () => {},
      required: true,
    },
    inboxId: {
      type: Number,
      required: true,
    },
    singleReason: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      title: '',
      isLoading: false,
      selectedResolutionType: this.reason?.resolution_type || '',
      resolutionOptions: [
        {
          id: 'objective_achieved',
          title: this.$t('CONVERSATION.RESOLUTION_MODAL.OPTIONS.FIRST_LABEL'),
          checked: false,
        },
        {
          id: 'objective_not_achieved',
          title: this.$t('CONVERSATION.RESOLUTION_MODAL.OPTIONS.SECOND_LABEL'),
          checked: false,
        },
        {
          id: 'doubt',
          title: this.$t('CONVERSATION.RESOLUTION_MODAL.OPTIONS.THIRD_LABEL'),
          checked: false,
        },
        {
          id: 'other',
          title: this.$t('CONVERSATION.RESOLUTION_MODAL.OPTIONS.FOURTH_LABEL'),
          checked: false,
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      this.title = this.reason.title;
      this.selectedResolutionType = this.reason.resolution_type;
      this.resolutionOptions.find(
        e => e.id === this.selectedResolutionType
      ).checked = true;
    },
    async editReason() {
      const payload = {
        inboxId: this.inboxId,
        title: this.title,
        resolutionType: this.selectedResolutionType,
        conversationResolutionId: this.reason.id,
      };
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          'inboxes/updateConversationResolutionReason',
          payload
        );
        this.onClose();
        useAlert(
          this.$t(
            'INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.EDIT.API.SUCCESS_MESSAGE'
          )
        );
      } catch (error) {
        useAlert(
          this.$t(
            'INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.EDIT.API.ERROR_MESSAGE'
          )
        );
        this.isLoading = false;
      }
    },
    onChangeResolutionOption(selectedOption) {
      this.selectedResolutionType = selectedOption;
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div class="h-auto overflow-auto flex flex-col pb-5">
    <woot-modal-header
      :header-title="
        $t('INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.EDIT.HEADER')
      "
    />
    <div class="pl-8">
      <label>{{
        $t(
          'INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.EDIT.RESOLUTION_TYPE'
        )
      }}</label>
      <span v-if="singleReason" class="text-xxs">
        {{
          $t(
            'INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.DELETE.TOOLTIP_SINGLE_OPTION'
          )
        }}
      </span>
      <InputRadioGroup
        name="widget-screen"
        class="mb-3"
        :items="resolutionOptions"
        :initial-option="selectedResolutionType"
        :disable-buttons="singleReason"
        @on-change-resolution-option="onChangeResolutionOption"
      />
      <woot-input
        v-model.trim="title"
        v-tooltip.bottom="title"
        class="w-full pr-10"
        :label="
          $t('INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.EDIT.LABEL')
        "
        :placeholder="
          $t(
            'INBOX_MGMT.EDIT.CONVERSATION_RESOLUTION.REASONS.EDIT.PLACE_HOLDER'
          )
        "
      />

      <div class="flex justify-end items-center py-2 px-0 gap-2 w-full">
        <woot-button :is-loading="isLoading" @click="editReason">
          {{ $t('LABEL_MGMT.FORM.EDIT') }}
        </woot-button>
        <woot-button
          :is-loading="isLoading"
          class="button clear"
          @click="onClose"
        >
          {{ $t('LABEL_MGMT.FORM.CANCEL') }}
        </woot-button>
      </div>
    </div>
  </div>
</template>
